webpackJsonp([8],{

/***/ "../../node_modules/reduce-reducers/es/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  for (var _len = arguments.length, reducers = Array(_len), _key = 0; _key < _len; _key++) {
    reducers[_key] = arguments[_key];
  }

  return function (previous, current) {
    for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      args[_key2 - 2] = arguments[_key2];
    }

    return reducers.reduce(function (p, r) {
      return r.apply(undefined, [p, current].concat(args));
    }, previous);
  };
});

/***/ }),

/***/ "./react/school-master.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__("../../node_modules/ramda/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__("../../node_modules/react-dom/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("../../node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__("../../node_modules/redux/es/redux.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reduce_reducers__ = __webpack_require__("../../node_modules/reduce-reducers/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_utils_objects__ = __webpack_require__("./react/utils/objects.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_utils_f__ = __webpack_require__("./react/utils/f.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_store_createStore__ = __webpack_require__("./react/store/createStore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_school_master_app_keys__ = __webpack_require__("./react/school-master/app-keys.js");
/**
 * This is an app that combines a few other 'apps' together
 * so that they can access each other's data and actions.
 *
 * It does this by taking a definition from each app that
 * can describe certain store actions that it wants to receive
 * from other apps. Those actions are then monitored and passed
 * along to other apps that request them, as though they were
 * actions native to that 'app'.
 *
 * The benefit of this approeach is that most of each app
 * is ignorant that this is happening. The only change
 * each app needs to make is to register a definition object
 * instead of creating a store and rendering its own
 * component.
 *
 * The downside is the added complexity, but that is
 * restricted to this file.
 *
 * See one of the apps included below to see what a definition
 * should look like.
 *
 */












var renderApp = function renderApp(app) {
    app.components && app.components.forEach(function (x) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_redux__["Provider"],
            { store: app.store },
            x.component
        ), x.el);
    });

    return app;
};

var setStore = function setStore(app) {
    app.store = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_app_store_createStore__["a" /* default */])(app.reducer, app.state);
    return app;
};

// adds a global reducer to each app that will monitor for actions
// and trigger than on the stores of other, interested apps.
var monitorActions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_ramda__["curry"])(function (apps, appKey, app) {
    // find other apps that want actions from this app
    var getInterestedApps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_ramda__["compose"])(__WEBPACK_IMPORTED_MODULE_1_ramda__["flatten"], Object.values, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_ramda__["map"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_ramda__["filter"])(function (x) {
        return !!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_ramda__["path"])(['pullActions', appKey], x);
    })), // apps that want actions from this app
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_app_utils_f__["b" /* filterKV */])(function (v, k) {
        return k !== appKey;
    }) // exclude the current app
    );

    var interestedApps = getInterestedApps(apps);

    var godReducer = function godReducer() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        // no interested apps
        if (!interestedApps.length) return state;

        interestedApps.forEach(function (x) {
            var translatedActionType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_ramda__["path"])(['pullActions', appKey, action.type], x);

            // not monitoring this action
            if (!translatedActionType) return;

            // redux is going to throw an exception if we encounter an infinite loop (e.g. when two apps are
            // listening to each other on the same action). so use it's mechanism for detecting that to save
            // us the trouble of implementing it.
            try {
                // trigger the action on the other app
                x.store && x.store.dispatch(Object.assign({}, action, { type: translatedActionType }));
            } catch (_) {}
        });

        return state;
    };

    var monitoredReducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_reduce_reducers__["a" /* default */])(app.reducer, godReducer);

    app.reducer = monitoredReducer;
    app.updateReducerOnNewApp = function () {
        interestedApps = getInterestedApps(apps);
    };

    return app;
});

var runOnLoad = function runOnLoad(app) {
    if (app.onLoad) app.onLoad(app.store);

    return app;
};

var apps = {};

window.AboundSchoolMaster = {
    // this function allows the apps to register themselves, so this
    // bundle doesn't get huge by aggresively including all apps that
    // might use this functionality. each apps[key] value is an array
    // of apps registered at that key, so can register more than one
    // app at a single key
    registerApp: function registerApp(appKey, app) {
        if (!apps[appKey]) apps[appKey] = [];

        apps[appKey].push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_ramda__["compose"])(renderApp, runOnLoad, setStore, monitorActions(apps, appKey))(app));

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_ramda__["forEachObjIndexed"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_ramda__["forEach"])(function (x) {
            x.updateReducerOnNewApp();
        }), apps);

        return apps[appKey].length - 1; // return the index of the app, in this key
    },

    getStore: function getStore(appKey) {
        var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_ramda__["path"])([appKey, i, 'store'], apps);
    }
};

/***/ }),

/***/ "./react/school-master/app-keys.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MY_SCHOOLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MY_SCHOOLS_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MY_SAVED_SCHOOLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SAVE_SCHOOL_BUTTON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SCHOOL_BROWSER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SCHOOL_TRIGGER; });
var MY_SCHOOLS = 'MY_SCHOOLS';
var MY_SCHOOLS_SETTINGS = 'MY_SCHOOLS_SETTINGS';
var MY_SAVED_SCHOOLS = 'MY_SAVED_SCHOOLS';
var SAVE_SCHOOL_BUTTON = 'SAVE_SCHOOL_BUTTON';
var SCHOOL_BROWSER = 'SCHOOL_BROWSER';
var SCHOOL_TRIGGER = 'SCHOOL_TRIGGER';

/***/ }),

/***/ "./react/store/createStore.dev.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__("../../node_modules/redux/es/redux.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk__ = __webpack_require__("../../node_modules/redux-thunk/es/index.js");



// need to do is this way so that the dev store will work with browsers other than Chrome
var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || __WEBPACK_IMPORTED_MODULE_0_redux__["compose"];

var middlewares = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["applyMiddleware"])(__WEBPACK_IMPORTED_MODULE_1_redux_thunk__["default"]);
var enhancers = composeEnhancers(middlewares);

/* unused harmony default export */ var _unused_webpack_default_export = (function (reducer, initialState) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["createStore"])(reducer, initialState, enhancers);
});

/***/ }),

/***/ "./react/store/createStore.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore_prod__ = __webpack_require__("./react/store/createStore.prod.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createStore_dev__ = __webpack_require__("./react/store/createStore.dev.js");



var createStore =  true ? __WEBPACK_IMPORTED_MODULE_0__createStore_prod__["a" /* default */] : createDevStore;

/* harmony default export */ __webpack_exports__["a"] = (createStore);

/***/ }),

/***/ "./react/store/createStore.prod.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__("../../node_modules/redux/es/redux.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk__ = __webpack_require__("../../node_modules/redux-thunk/es/index.js");



var middlewares = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["applyMiddleware"])(__WEBPACK_IMPORTED_MODULE_1_redux_thunk__["default"]);
var enhancer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["compose"])(middlewares);

/* harmony default export */ __webpack_exports__["a"] = (function (reducer, initialState) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["createStore"])(reducer, initialState, enhancer);
});

/***/ }),

/***/ "./react/utils/objects.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hasProperties;
/* harmony export (immutable) */ __webpack_exports__["b"] = getNumericallyKeyedValues;
/* unused harmony export isObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda__ = __webpack_require__("../../node_modules/ramda/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_utils_f__ = __webpack_require__("./react/utils/f.js");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




function hasProperties(x) {
    for (var prop in x) {
        if (Object.prototype.hasOwnProperty.call(x, prop)) {
            return true;
        }
    }

    return false;
}

// Gets values from an object that are numerically keyed (e.g. keys 1, 2, '1', '400')
// and returns those values as an array. Does not preserve keys. Useful for getting
// items from an object that was created in PHP from an array like ['a', 'b', 'list' => ['q', 'd']].
// In that example, this function would return ['a', 'b']. If the value provided is
// already an array, just returns the array.
function getNumericallyKeyedValues(xs) {
    return Array.isArray(xs) ? xs : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_ramda__["compose"])(Object.values, // convert to array
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_app_utils_f__["b" /* filterKV */])(function (v, k) {
        return !isNaN(k);
    }) // only get items with numeric keys
    )(xs);
}

function isObject(x) {
    return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === "object" && x !== null;
}

/***/ })

},["./react/school-master.js"]);


// WEBPACK FOOTER //
// scripts/school-master.1a8cc3b04bbe81f80918.js